export default {
  app: localStorage.getItem('app') || 'web', // android || ios || web

  callingAPI: false,
  searching: '',
  serverURI: '',
  serverURL: 'http://0.0.0.0:80',
  backendURL: 'http://34.87.103.204:80/v1',
  captchaSiteKey: (process.env.NODE_ENV == 'development') ? '6LdJgMUkAAAAANwheJ3H2ZbQjesyanANH-i42yNm' : '6Le3EfckAAAAAJbr49YZeQy2dfpEm9NxS1NAvvyK',
  geolocation: JSON.parse(localStorage.getItem('geolocation')) || null,
  appName: localStorage.getItem('appName') || 'MetalGo', // MetalGo || PosPayGold || NUNomics || BMTDigi || AGIGold
  instantLogin: JSON.parse(localStorage.getItem('instantLogin')) || false,
  account: JSON.parse(localStorage.getItem('account')) || null,
  kinesisCookieSession: JSON.parse(localStorage.getItem('kinesisCookieSession')) || null,
  tradingType: JSON.parse(localStorage.getItem('tradingType')) || 'jgx',
  balances: null,
  balanceIdr: 0,
  balanceUsd: 0,
  kinesisBalanceIdr: 0,
  kinesisBalanceUsd: 0,
  availableTradeBalanceUsd: 0,
  availableTradeBalanceIdr: 0,
  accountBalance: 0,
  reservedBalance: 0,
  token: localStorage.getItem('token') || null,
  status: null,
  contracts: null,
  depths: null,
  kinesisDepth: null,
  golds: null,
  products: null,
  orderInTradeTicket: null,
  timerBarStatus: false,
  streamingRate: JSON.parse(localStorage.getItem('streamingRate')) || null,
  currency: JSON.parse(localStorage.getItem('currency')) || 'idr', //usd || idr
  srcVideo: '',
  getDepositIsCooldown: false,
  holdings: null,
  hubs: null,
  hub: JSON.parse(localStorage.getItem('hub')) || 'jakarta',

  customDepths: {},

  demoAccountId: localStorage.getItem('demoAccountId') || '-',
  demoToken: localStorage.getItem('demoToken') || '-',

  reportToShow: window.localStorage.getItem('tabActiveReports') || 'orders', // orders || transactions || holdings || accountBalanceHistory

  // Api Status ==========================================================
  setContractsApiStatus: 'idle',
  setProductsApiStatus: 'idle',
  setAccountInformationApiStatus: 'idle',
  setDepthsApiStatus: 'idle',
  setStreamingRateApiStatus: 'idle',
  setBalancesApiStatus: 'idle',
  setGoldBalanceApiStatus: 'idle',

  setContract: 'idle', // idle || loading || success || error
  setContracts: 'idle',
  marketInquiryStatus: 'idle',
  depositWithdrawalHistoryStatus: 'idle',
  reqWithdrawalStatus: 'idle',
  setBalanceStatus: 'idle',
  marketStatus: 'open',
  setDetailOrder_status: 'idle',

  // Swal status
  swalSessionExpiredOn: 'off', // off || on

  // userInfo: {
  //   messages: [
  //     {
  //       id: 1,
  //       title: 'Support Team',
  //       body: 'Why not consider this a test message?',
  //       createdAt: '17 min ago'
  //     }
  //   ],
  //   notifications: [
  //     {
  //       id: 1,
  //       title: 'Birthday Reminder',
  //       body: 'Today is Brians birthday.',
  //       createdAt: 'just now',
  //       readAt: null
  //     },
  //     {
  //       id: 2,
  //       title: 'Bank Holiday in London',
  //       body: 'Our office in London has a bank holiday today. Do not expect them to answer the phone.',
  //       createdAt: '4 hours ago',
  //       readAt: null
  //     },
  //     {
  //       id: 3,
  //       title: 'Birthday Reminder',
  //       body: 'Today is Christians birthday.',
  //       createdAt: '27 days ago',
  //       readAt: '2018-08-12 00:00:00'
  //     },
  //     {
  //       id: 4,
  //       title: 'Birthday Reminder',
  //       body: 'Today is Tanjas birthday.',
  //       createdAt: '29 days ago',
  //       readAt: '2018-08-12 00:00:00'
  //     },
  //     {
  //       id: 5,
  //       title: 'Sales Bonus received',
  //       body: 'You received your monthly sales bonus of 3%. This month you made $2,700 extra!',
  //       createdAt: '7 hours ago',
  //       readAt: null
  //     }
  //   ],
  //   tasks: []
  // }


  // Config ==============================================================

  loginExpiredTimeState: 900000, //milisecond
  refreshTokenTimeState: 90000, //milisecond

  nextGetStreamingRate: window.localStorage.getItem('nextGetStreamingRate') || null,

  // this is the contract id corresponding to the true weight and to "fake" weight
  trueContractIds: {
    contractId_001g: process.env.NODE_ENV == 'development' ? 5 : 5,
    contractId_1g: process.env.NODE_ENV == 'development' ? 6 : 6,
    contractId_100g: process.env.NODE_ENV == 'development' ? 626 : 626,
    contractId_10kg: process.env.NODE_ENV == 'development' ? 633 : 633,
    contractId_10oz: process.env.NODE_ENV == 'development' ? 271 : 271,
    contractId_1kg: process.env.NODE_ENV == 'development' ? 264 : 264,
  },

  // this is the contract id that will be used in the app
  contractIds: {
    contractId_001g: process.env.NODE_ENV == 'development' ? 5 : 5,
    contractId_1g: process.env.NODE_ENV == 'development' ? 6 : 6,
    contractId_100g: process.env.NODE_ENV == 'development' ? 626 : 626, //GCGHK1
    contractId_10kg: process.env.NODE_ENV == 'development' ? 633 : 633, //GMWHK1
    contractId_10oz: process.env.NODE_ENV == 'development' ? 271 : 271, //GXOHK1
    contractId_1kg: process.env.NODE_ENV == 'development' ? 264 : 264, //GMGHK1
  },

  get contractConfigs() {
    return {
      [this.trueContractIds.contractId_001g]: { // 100g -> 0.01g
        contractStatus: 'active',

        weightInGram: 0.01,
        weightMultiplication: 1,
        weightCorrection: 0.0001,
        depthTTDecimalPlace: 4,
        tbTtDecimalPlace: 4,
        depthQuantityDecimalPlace: 5,
        hasQuantityDecimal: false,

        codeName: 'DG001',
        tradeTicketName: '0.01 g pool',
        name: '0.01 g pool',
        tradeBoxName: '0.01 g pool',
        rrsName: 'DG001 0.01 G POOL',

        realAccountOnly: true,

        isReviewOrderButtonDisabledBuyMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledBuyLimit: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellLimit: process.env.NODE_ENV == 'development' ? false : false,

        ohlcId: -1,
      },

      [this.trueContractIds.contractId_1g]: { // 100g -> 1g
        contractStatus: 'active',

        weightInGram: 1,
        weightMultiplication: 1,
        weightCorrection: 0.01,
        depthTTDecimalPlace: 2,
        tbTtDecimalPlace: 2,
        depthQuantityDecimalPlace: 5,
        hasQuantityDecimal: false,
        
        codeName: 'DG1',
        tradeTicketName: '1 g pool',
        name: '1 g pool',
        tradeBoxName: '1 g pool',
        rrsName: 'DG1 1 G POOL',

        realAccountOnly: true,

        isReviewOrderButtonDisabledBuyMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledBuyLimit: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellLimit: process.env.NODE_ENV == 'development' ? false : false,

        ohlcId: -1,
      },

      [this.trueContractIds.contractId_100g]: { // 100 gram
        contractStatus: 'active', // 'active' || 'disabled'

        weightInGram: 100,

        /*
        weightMultiplication -> this variable was made because contract 0.01 price 
        is count per 0.01 gram, unlike other contract that count per 1 gram.
        So when you want to get the contract price from "price per gram" 
        you need to multiply it with this variable, NOT weightInGram.
        */
        weightMultiplication: 100,

        //dividing weightInGram by weightCorrection will get the original weight
        weightCorrection: 1,

        //Number of digit behind decimal point for PRICE in DEPTH
        depthTTDecimalPlace: 2,

        // Number of digit behind decimal point for PRICE in TRADEBOX and TRADETICKET
        tbTtDecimalPlace: 2,

        //Number of digit behind decimal point for QUANTITY in DEPTH
        depthQuantityDecimalPlace: 5,

        //hasQuantityDecimal. If true, it will have quantity decimal in form.
        hasQuantityDecimal: false,

        // codeName: 'GCGHK1',
        // tradeTicketName: '100 g Swiss Bar',
        // tradeTicketName: '100 g Swiss Bar',
        // name: '100 g Swiss Bar',
        // tradeBoxName: '100 g Swiss Bar',
        // rrsName: 'GCGHK1 100 g Swiss Bar',

        codeName: 'DG100',
        tradeTicketName: '100 g non pool',
        name: '100 g non pool',
        tradeBoxName: '100 g non pool',
        rrsName: 'DG100 100 g non pool',

        realAccountOnly: false,

        // for Review Order button on Trade Ticket for this contract with this condition
        isReviewOrderButtonDisabledBuyMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledBuyLimit: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellLimit: process.env.NODE_ENV == 'development' ? false : false,

        ohlcId: this.trueContractIds.contractId_100g,
      },

      [this.trueContractIds.contractId_10kg]: { // 10kg
        contractStatus: 'active',

        weightInGram: 10000,
        weightMultiplication: 10000,
        weightCorrection: 1,
        depthTTDecimalPlace: 2,
        tbTtDecimalPlace: 2,
        depthQuantityDecimalPlace: 5,
        hasQuantityDecimal: false,

        // codeName: 'GMWHK1',
        // tradeTicketName: 'Wholesale AAU 10 kg',
        // name: 'Wholesale AAU 10 kg',
        // tradeBoxName: 'Wholesale AAU 10 kg',
        // rrsName: 'GMWHK1 Wholesale AAU 10 kg',

        codeName: 'DG10K',
        tradeTicketName: '10 kg non pool',
        name: '10 kg non pool',
        tradeBoxName: '10 kg non pool',
        rrsName: 'DG10K 10 kg non pool',

        realAccountOnly: false,

        isReviewOrderButtonDisabledBuyMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledBuyLimit: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellLimit: process.env.NODE_ENV == 'development' ? false : false,

        ohlcId: -1,
      },

      [this.trueContractIds.contractId_1kg]: { // 1kg
        contractStatus: 'disabled', // 'active' || 'disabled

        weightInGram: 1000,
        weightMultiplication: 1000,
        weightCorrection: 1,
        depthTTDecimalPlace: 2,
        tbTtDecimalPlace: 2,
        depthQuantityDecimalPlace: 5,
        hasQuantityDecimal: false,
        
        codeName: 'GXOHK1',
        tradeTicketName: '10 oz Swiss Bar',
        name: '10 oz Swiss Bar',
        tradeBoxName: '10 oz Swiss Bar',
        rrsName: 'GXOHK1 10 oz Swiss Bar',

        realAccountOnly: false,

        isReviewOrderButtonDisabledBuyMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledBuyLimit: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellLimit: process.env.NODE_ENV == 'development' ? false : false,

        ohlcId: -1,
      },

      [this.trueContractIds.contractId_10oz]: { // 10oz
        contractStatus: 'active',

        weightInGram: 311.04,
        weightMultiplication: 311.04,
        weightCorrection: 1,
        depthTTDecimalPlace: 2,
        tbTtDecimalPlace: 2,
        depthQuantityDecimalPlace: 5,
        hasQuantityDecimal: false,

        codeName: 'GMGHK1',
        tradeTicketName: '1 kg Bar',
        name: '1 kg Bar',
        tradeBoxName: '1 kg Bar',
        rrsName: 'GMGHK1 1 kg Bar',

        codeName: 'DG1K',
        tradeTicketName: '1 kg Bar',
        name: '1 kg Bar',
        tradeBoxName: '1 kg Bar',
        rrsName: 'DG1K 1 kg Bar',

        realAccountOnly: false,

        isReviewOrderButtonDisabledBuyMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledBuyLimit: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellMarket: process.env.NODE_ENV == 'development' ? false : false,
        isReviewOrderButtonDisabledSellLimit: process.env.NODE_ENV == 'development' ? false : false,

        ohlcId: -1,
      },
    }
  },


  // fee and tax
  fee: 0.01, // 1% of value
  feeMin: 0.036,
  tax: 0.11, // 11% of fee
  taxMin: 0.004,

  feeTaxMultiplier: 0.0111, // 1.11% of value
  feeTaxMin: 0.04, // $0.04
  totalIdrMin: 50000, // if total idr less than this, then (fee + tax = $0.04) Or (fee = $0.036 and tax = $0.004)

  // fx buffer
  fxBuffer: 0.05,
  fxBufferMin: 0.01,

  // percent away from current price. For order limit.
  minMaxLimitPriceKAU: 0.1, // 10 percent from price per gram
  minMaxLimitPriceIGX: 0.15, // 15 percent from price per gram

  get filterContract() {
    return [
      {
        contractId: this.contractIds.contractId_100g,
        name: '100 g',
        checked: true,
      },
      {
        contractId: this.contractIds.contractId_10oz,
        name: '10 oz',
        checked: true,
      },      
      {
        contractId: this.contractIds.contractId_1kg,
        name: '1 kg',
        checked: true,
      },
      {
        contractId: this.contractIds.contractId_10kg,
        name: '10 kg',
        checked: true,
      },
    ]
  },

  // Default order of gold shown in RRS 
  get goldOrderRrs() {
    return [this.contractIds.contractId_100g, this.contractIds.contractId_10oz, this.contractIds.contractId_1kg, this.contractIds.contractId_10kg]
  },

  get reservedGoldOrder() {
    return [
      {
        contractId: this.contractIds.contractId_100g,
        name: '100 g'
      },
      {
        contractId: this.contractIds.contractId_10oz,
        name: '10 oz'
      },
      {
        contractId: this.contractIds.contractId_1kg,
        name: '1 kg'
      },
      {
        contractId: this.contractIds.contractId_10kg,
        name: '10 kg'
      },
    ]
  }
}
